import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { ProjectTab } from '@trinity/chat/types/entity-tabs';
import { useChatApiClient } from '../containers/Chat/useApiClient';
import { entityPageQueryKeys } from './useEntityPages';

/** The tabs chat-api says the caller may see on a project, in order. */
export function useProjectTabs(projectId: number | null): UseQueryResult<ProjectTab[]> {
  const apiClient = useChatApiClient();

  return useQuery({
    queryKey: entityPageQueryKeys.tabs({ type: 'project', id: projectId ?? 0 }),
    queryFn: async () => {
      if (projectId === null) {
        throw new Error('projectId is required to fetch project tabs');
      }

      return apiClient.projects.getProjectTabs(projectId);
    },
    enabled: projectId !== null,
  });
}
